// eslint-disable-next-line import/no-anonymous-default-export
export default (url, width = 700) => {
	let urlSplited = url.split('/');
	urlSplited[5] += `/w_${width}`;
	let backgroundImage = urlSplited.join('/');
	return backgroundImage;
};
